import { useTranslation } from 'react-i18next'
import contextialiseChatImg from '../../../assets/New-images/contextualised-chat-img.svg'
import genQueAnsImg from '../../../assets/New-images/gen-que-ans-img.svg'
import learningOutcomesImg from '../../../assets/New-images/learning-outcomes-img.svg'
import manageConversationFlow from '../../../assets/New-images/manage-conversation-flow.svg'
import mangeKeyPhrase from '../../../assets/New-images/manage-key-phrase.svg'
import summariseDocImg from '../../../assets/New-images/summarise-doc-img.svg'
import { CONVERSATION_FLOW, KNOWLEDGE_KEYPHRASES } from '../../../config'
import { ExploreButton } from '../ExploreButton'
import { PureCarousel } from '../PureCarousel'

function KnowledgeCarousel(): JSX.Element {
  const { t } = useTranslation('translation')

  const CAROUSEL_DATA = [
    {
      name: t('Set Up Contextualised Chat'),
      description: t(
        'Upload your content to serve as sources for your AI assistant’s responses',
      ),
      icon: contextialiseChatImg,
      route: `/knowledge/setup/chat`,
    },
    // {
    //   name: t('Generate Q&As'),
    //   description: t(
    //     'Extract essential points from your content and create Q&A flashcards',
    //   ),
    //   icon: genQueAnsImg,
    //   route: `/knowledge/setup/generate-qa`,
    // },
    {
      name: t('Set Learning Outcomes'),
      description: t('Align generated content by setting learning outcomes'),
      icon: learningOutcomesImg,
      route: `/knowledge/setup/learning-outcomes`,
    },
    {
      name: t('Summarise Document(s)'),
      description: t(
        'Create contents by summarising or merging existing documents',
      ),
      icon: summariseDocImg,
      route: `/knowledge/setup/summarise-doc`,
    },
    {
      name: t('Manage Key Phrases'),
      description: t(
        'Define and link key phrases to improve your contextual responses',
      ),
      icon: mangeKeyPhrase,
      route: KNOWLEDGE_KEYPHRASES,
    },
    {
      name: t('Manage Conversation Flow'),
      description: t(
        'Set up and connect content for a tailored chat experience',
      ),
      icon: manageConversationFlow,
      route: CONVERSATION_FLOW,
    },
  ]

  return (
    <div>
      <PureCarousel>
        {CAROUSEL_DATA.map((item, index) => {
          return (
            <ExploreButton
              key={index}
              title={item.name}
              route={item.route}
              icon={item.icon}
              fullWidth
            />
          )
        })}
      </PureCarousel>
    </div>
  )
}

export default KnowledgeCarousel
